import { render, staticRenderFns } from "./NominationList14A.vue?vue&type=template&id=620ecc5a"
import script from "./NominationList14A.vue?vue&type=script&lang=js"
export * from "./NominationList14A.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports